import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FileText, ArrowLeft, User } from 'lucide-react';
import { appName } from '../../config/branding';

const CustomerDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="fixed inset-y-0 left-0 z-40 w-64 bg-white border-r border-gray-200 hidden md:block">
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-5 border-b border-gray-100">
            <a href="/" className="inline-block">
              <svg width="160" height="28" viewBox="0 0 160 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <text x="0" y="22" fontFamily="Inter, sans-serif" fontSize="18" fontWeight="800" fill="#37b34a">{appName}</text>
              </svg>
            </a>
            <p className="text-xs text-gray-400 mt-1">Customer Dashboard</p>
          </div>

          {/* Profile Card */}
          {user && (
            <div className="p-4 border-b border-gray-100">
              <div className="flex items-center gap-3">
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="w-10 h-10 rounded-lg object-cover" />
                ) : (
                  <div className="w-10 h-10 rounded-lg bg-[#37b34a] flex items-center justify-center text-white font-bold">
                    {user.name?.charAt(0)?.toUpperCase() || 'U'}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-900 truncate">{user.name}</p>
                  <p className="text-xs text-gray-500 truncate">{user.email}</p>
                </div>
              </div>
            </div>
          )}

          {/* Navigation */}
          <nav className="flex-1 p-3 space-y-1">
            <NavLink
              to="/dashboard/customer/requests"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-[#37b34a]/10 text-[#37b34a]'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <FileText size={18} />
              My Requests
            </NavLink>
          </nav>

          {/* Back */}
          <div className="p-4 border-t border-gray-100">
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors w-full"
            >
              <ArrowLeft size={16} />
              Back to home
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 md:ml-64 min-w-0">
        <div className="p-4 md:p-8 max-w-[1100px]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboard;
